import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "nav-tabs-navigation"
};
var _hoisted_2 = {
  "class": "nav-tabs-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "nav")])]), _createElementVNode("div", null, [_renderSlot(_ctx.$slots, "content")])]);
}